import React, { forwardRef, useState, useEffect, Fragment, useRef } from "react";
import { translate } from "../../Services/translation";
import LensSpecification from "./LensSpecificationSelection";
import LightboxImages from "../LightboxImages";
import { get } from '../../Services/http';
import { useSelector } from "react-redux";

const ProductPage = (props) => {
    const [productItem, setproductItem] = useState([]);
    var packageSizes = JSON.parse(props.variantPackageSizes);
    var similarProducts = JSON.parse(props.similarProducts);
    const packageSizeWrapper = document.getElementById('packageSizeWrapper');
    const cart = useSelector((state) => state.cart);
    const [subscriptionSelected, setsubscriptionSelected] = useState(false);
    const [numberOfPackets, setnumberOfPackets] = useState([]);
    const [isExpanded, setIsExpanded] = useState(false);
    const [needsToggle, setNeedsToggle] = useState(false);
    const uspListRef = useRef(null);
    const [subscriptionAvailable, setsubscriptionAvailable] = useState(false);

    useEffect(() => {
        getProductItem(props.variant);        

        if (packageSizes.some(x => x.articleNumber === props.variant && x.availableForSubscription)) {
            setsubscriptionSelected(true);
            setsubscriptionAvailable(true);
            setInputChecked(true, props.variant);
        } else {
            setInputChecked(false, props.variant);
        }
    }, []);


    useEffect(() => {
        if (productItem.subscriptionDescriptionBlock) {
            setNeedsToggle(true);
        }
    }, [productItem]);

    const toggleText = () => {
        setIsExpanded(!isExpanded);
    };

    const getProductItem = (articleNumber) => {
        get(`/api/product/getproductitem?articleNumber=${articleNumber}`)
            .then((response) => response.json())
            .then((result) => {
                setproductItem(result);
                setnumberOfPackets(result.numberOfPackets);

                if (window.innerWidth <= 760) {
                    packageSizeWrapper.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start',
                        inline: 'start'
                    });
                }
            });
    }

    useEffect(() => {
        if (cart) {
            var filteredProduct = packageSizes.filter(x => x.articleNumber === productItem.articleNumber);
            if ((cart.subscriptionExistsForRightEye || cart.subscriptionExistsForLeftEye) && filteredProduct && filteredProduct.availableForSubscription) {
                setsubscriptionSelected(true);
            } else if (cart.nonSubscriptionProductExists) {
                setsubscriptionSelected(false);
            }            
        }
    }, [cart]);

    useEffect(() => {
        if (productItem && productItem.name) {
            if (subscriptionSelected) {
                setnumberOfPackets(productItem.numberOfPackets.filter(x => x <= productItem.maximumNumberOfPackagesForSubscription));
            } else {
                setnumberOfPackets(productItem.numberOfPackets);
            }
        }
    }, [productItem, subscriptionSelected]);


    const setInputChecked = (isSubscription, articleNumber) => {
        var allInputEelements = document.querySelectorAll(".product-detail__article-check");
        allInputEelements.forEach(inputItem => {
            if (inputItem.defaultValue === articleNumber && !isSubscription) {
                inputItem.checked = true;
            }
            else {
                inputItem.checked = false;
            }
        });
    }

    return (
        <Fragment>
            <div className="small-6 columns product-detail__images">
                <LightboxImages images={productItem.lightBoxLazyLoadImagesUrl}></LightboxImages>
                {productItem.description &&
                    <div className="product-detail__description-wrapper show-large">
                        <h3 className="product-detail__description-title" id="descriptionTitle">{translate("coptikk.description.title")}</h3>
                        <div itemProp="description" className="product-detail__description" id="descriptionText" 
                        dangerouslySetInnerHTML={{ __html : productItem.description }}></div>
                    </div>
                }
            </div>
            <div className="small-6 columns product-detail__detail-wrapper">
                <div className="product-detail__details">
                    <hgroup>
                        {productItem.brand &&
                            <h2 className="product-detail__brand" itemProp="brand">{productItem.brand}</h2>
                        }
                        <h1 className="product-detail__name" itemProp="name">{productItem.name}</h1>
                    </hgroup>
                    <div className="product-detail__category-label">
                        <a href={productItem.categoryUrl}>{productItem.categoryName}</a>
                    </div>
                    {productItem.notAvailable &&
                        <div className="product-detail__alert-message">
                            <div className="alert-icon">!</div>
                            <div className="text">{translate("coptikk.product.alert.message")}</div>
                        </div>
                    }
                    {productItem.price && productItem.price.price &&
                        <>
                            <meta itemProp="sku" content={productItem.price.price.unitOfMeasurementTitle} />
                            <div itemProp="offers" itemScope itemType="http://schema.org/Offer">
                                <link itemProp="url" href={productItem.url} />
                                <div className="product-detail__price-info">

                                    {productItem.campaignPrice && productItem.campaignPrice.price ?
                                        <>
                                            <span className="product__campaign-price">
                                                {productItem.campaignPrice.price}
                                            </span>
                                            <span className="product__old-price">
                                                {productItem.price.price.priceWithVat}
                                            </span>
                                        </>
                                        :
                                        <>
                                            <span className="price">
                                                {productItem.price.price.priceWithVat}
                                            </span>
                                            <meta itemProp="price" content={productItem.price.price.priceWitVat} />
                                            <meta itemProp="priceCurrency" content="NOK" />
                                        </>
                                    }
                                </div>
                            </div>
                        </>}

                    <div>
                        {cart.nonSubscriptionProductExists && subscriptionAvailable &&
                            <div className="product-detail__disabled-message-wrapper">
                                <div className="info-icon">i</div>
                                <div className="product-detail__disabled-message">
                                    {translate("coptikk.product.disabledmessage.subscription")}
                                </div>
                            </div>
                        }
                        {(cart.subscriptionExistsForLeftEye || cart.subscriptionExistsForRightEye) &&
                            <div className="product-detail__disabled-message-wrapper">
                                <div className="info-icon">i</div>
                                <div className="product-detail__disabled-message">
                                    {translate("coptikk.product.disabledmessage.onetimeshop")}
                                </div>
                            </div>
                        }
                        <div className="row">
                            <div className="small-12 columns product-detail__package-size" id="packageSizeWrapper">
                                {packageSizes &&
                                    <>
                                        <h2 className="product-detail__package-size-text">{translate("coptikk.general.packagesizes")}</h2>
                                        <ul className="product-detail__variant-package-size" data-filter="colorfilter" id="sizefilter">
                                            <li className="product-detail__selector-item">
                                                {packageSizes.map(x => {
                                                    return (
                                                        <div key={x.title}>
                                                            {x.availableForSubscription &&
                                                                <a className={` product-detail__selector-link ${productItem.id === x.articleNumber &&
                                                                    subscriptionSelected
                                                                    ? " product-detail__selector-link--active" :
                                                                    (x.enabled ? "" : " product-detail__selector-link--disabled") +
                                                                    (cart.nonSubscriptionProductExists ? " product-detail__packagesize-disabled" : "")}`}
                                                                    onClick={() => {
                                                                        getProductItem(x.articleNumber);
                                                                        setsubscriptionSelected(true);
                                                                        setInputChecked(true, x.articleNumber);
                                                                    }
                                                                    }
                                                                >
                                                                    <div className="product-detail__typeofpurchase-section">
                                                                        <div className="select-wrapper">
                                                                            <input type="radio"
                                                                                checked={productItem.id === x.articleNumber && subscriptionSelected}
                                                                                disabled={cart.nonSubscriptionProductExists ||
                                                                                    (cart.lensDurationCategoryExistingInCart &&
                                                                                        cart.lensDurationCategoryExistingInCart !== productItem.lensDurationCategory)}></input>
                                                                            <div>{translate("coptikk.product.subscription")}</div>
                                                                        </div>
                                                                        <div>{x.title}</div>
                                                                    </div>
                                                                    <div>
                                                                        <div
                                                                            ref={uspListRef}
                                                                            className="product-detail__usp-list subscription"
                                                                            dangerouslySetInnerHTML={{ __html: productItem.subscriptionDescription }}
                                                                        ></div>
                                                                        {needsToggle && (
                                                                            <div onClick={toggleText} className="product-detail__usp-button">
                                                                                {isExpanded ?
                                                                                    <p className="show-less">{translate("coptikk.product.showless")}</p> :
                                                                                    <p className="read-more">{translate("coptikk.product.readmore")}</p>
                                                                                }
                                                                            </div>
                                                                        )}
                                                                        <div
                                                                            className={`product-detail__usp-list description-block ${isExpanded ? 'expanded' : 'collapsed'}`}
                                                                            dangerouslySetInnerHTML={{ __html: productItem.subscriptionDescriptionBlock }}
                                                                            ref={uspListRef}
                                                                        ></div>
                                                                    </div>
                                                                </a>
                                                            }
                                                            <a className={` product-detail__selector-link ${productItem.id === x.articleNumber && !subscriptionSelected
                                                                ? " product-detail__selector-link--active" :
                                                                (x.enabled ? "" : " product-detail__selector-link--disabled") +
                                                                ((cart.subscriptionExistsForRightEye || cart.subscriptionExistsForLeftEye) ? " product-detail__packagesize-disabled" : "")}`}
                                                                onClick={() => {
                                                                    getProductItem(x.articleNumber);
                                                                    setsubscriptionSelected(false);     
                                                                    setInputChecked(false, x.articleNumber);
                                                                }
                                                                }
                                                            >
                                                                <div className="product-detail__typeofpurchase-section">
                                                                    <div className="select-wrapper">
                                                                        <input type="radio" defaultValue={x.articleNumber}
                                                                            className={`product-detail__article-check`}
                                                                            disabled={(cart.subscriptionExistsForRightEye || cart.subscriptionExistsForLeftEye)}></input>
                                                                        <div>{translate("coptikk.product.onlyonetimeshop")}</div>
                                                                    </div>
                                                                    <div>{x.title}</div>
                                                                </div>
                                                                <div className="product-detail__usp-list" dangerouslySetInnerHTML={{ __html: productItem.oneTimeShopDescription }}></div>
                                                            </a>
                                                        </div>)
                                                })
                                                }
                                            </li>
                                        </ul>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" product-detail__variant-lens-specifications ">
                    {productItem.id && <LensSpecification key={productItem.id} currentVariantId={productItem.id}
                        numberOfPackets={numberOfPackets}
                        basePrice={productItem.price ? (productItem.price.campaignPrice ? productItem.price.campaignPrice.priceWithVat : (productItem.price?.price?.priceWithVat ?? 0)) : 0}
                        label={translate("coptikk.product.buy")}
                        articleNumber={productItem.id}
                        quantityFieldId={0}
                        href={productItem.url}
                        cssClass={'button buy-button product-detail__buy-button'}
                        notAvailable={productItem.notAvailable ? "True" : "False"}
                        loadFromState={true}
                        name={productItem.name}
                        image={productItem.lightBoxLazyLoadImagesUrl}
                        checkoutUrl={props.checkoutPage}
                        isAddingRecommendations={false}
                        availableForSubscription={productItem.availableForSubscription}
                        maximumNumberOfPackagesForSubscription={productItem.maximumNumberOfPackagesForSubscription}
                        lensDurationCategory={productItem.lensDurationCategory}
                        isSixMonthsDeliverySubscription={productItem.isSixMonthsDeliverySubscription}
                        subscriptionSelected={subscriptionSelected}
                    ></LensSpecification>}
                </div>
                {productItem.deliveryTime &&
                    <div className="product-detail__delivery-time">
                        {translate("coptikk.product.deliverytime")}
                        {productItem.deliveryTime}
                        {translate("coptikk.product.deliverytime.days")}
                    </div>
                }
                {productItem.Description &&
                    <div className="product-detail__description-wrapper show-mobile">
                        <h3 className="product-detail__description-title" id="descriptionTitleMobile">{translate("coptikk.description.title")}</h3>
                        <div itemProp="description" className="product-detail__description" id="descriptionTextMobile" 
                        dangerouslySetInnerHTML={{ __html:  productItem.Description}}></div>
                    </div>
                }
            </div>
            {productItem.notAvailable && <div className="product-detail__related-products">
                {similarProducts && similarProducts.length > 0 &&
                    <>
                        <h2 className="title">{translate("coptikk.related.products")}</h2>
                        <div className="row">
                            <div className="small-12 columns">
                                <ul className="row">

                                </ul>
                            </div>
                        </div>
                    </>
                }
                {similarProducts && similarProducts.map(similarProductItem => {
                    return (
                        <li className="small-6 medium-4 large-3 product__container">
                            <div itemScope itemType="http://schema.org/Product" className="product__wrapper">
                                <figure className="product__figure">
                                    {similarProductItem.lightBoxLazyLoadImagesUrl && similarProductItem.lightBoxLazyLoadImagesUrl.length > 0 ?
                                        <a href={similarProductItem.url} itemprop="url" class="product__image-link"
                                            dangerouslySetInnerHTML={{ __html: similarProductItem.lightBoxLazyLoadImagesUrl[0].html }}></a>
                                        : <span class="product__image--missing">{translate("product.noproductimage")}</span>}
                                </figure>
                                <article className="product__info">
                                    <meta itemProp="description" content={similarProductItem.description} />
                                    {similarProductItem.price &&
                                        <meta itemProp="sku" content={similarProductItem.price.price.unitOfMeasurementTitle} />
                                    }
                                    <a href={similarProductItem.url} title={similarProductItem.name}>
                                        <p itemProp="name" className="product__name">{similarProductItem.name}</p>
                                    </a>
                                    <p className="product__category-type">{similarProductItem.categoryName}</p>
                                    <div className="product__price" itemProp="offers" itemScope itemType="http://schema.org/Offer">
                                        {similarProductItem.price && similarProductItem.campaignPrice && similarProductItem.campaignPrice.price ?
                                            <>
                                                <span className="product__campaign-price">
                                                    {similarProductItem.campaignPrice.price}
                                                </span>
                                                <span className="product__old-price">
                                                    {similarProductItem.price.price.priceWithVat}
                                                </span>
                                            </>
                                            :
                                            <>
                                                <span className="price">
                                                    {similarProductItem.price.price.priceWithVat}
                                                </span>
                                                <meta itemProp="price" content={similarProductItem.price.price.priceWithVat} />
                                                <meta itemProp="priceCurrency" content="NOK" />
                                            </>
                                        }
                                        <span className="price-punctuation">,-</span>
                                        {similarProductItem.IsInStock ?
                                            <link itemProp="availability" href="http://schema.org/InStock" /> :
                                            <link itemProp="availability" href="http://schema.org/OutOfStock" />
                                        }
                                        <link itemProp="url" href={similarProductItem.url} />
                                    </div>
                                    <a href={similarProductItem.url} className="product__button">{translate("coptikk.product.show")}</a>
                                </article>
                            </div>
                        </li>)
                })}
            </div>}
        </Fragment>);
}

export default ProductPage;